function handleResponse(response) {
  return new Promise((resolve, reject) => {
    response.json().then(jsonBody => {
      if (response.ok) {
        return resolve(jsonBody);
      }

      return reject({
        status: response.status,
        headers: response.headers,
        body: jsonBody,
      });
    })
      .catch(() => (response.ok ? resolve(response) : reject(response)));
  });
}

export default class Api {
  constructor(url) {
    this._url = url;
  }

  header(customHeader) {
    let headers = {
      'Content-Type': 'application/json',
    };

    if (customHeader) {
      headers = {
        ...headers,
        ...customHeader
      };
    }

    return headers;
  }

  resetPasswordRequest(email) {
    return fetch(`${this._url}/api/users/resetPasswordRequest?email=${email}`, {
      method: 'get',
      mode: 'cors',
      headers: this.header(),
    })
      .then(handleResponse);
  }

  resetPassword(token, password) {
    return fetch(`${this._url}/api/users/resetPassword`, {
      method: 'post',
      body: JSON.stringify({ token, password }),
      mode: 'cors',
      headers: this.header(),
    })
      .then(handleResponse);
  }

}
